import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://vialratresearch.ca';
export const SITE_NAME = 'Vial Rat Research Co.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.png`;

/**
 * Reusable SEO head for the site.
 * - title / description / canonical are per-page
 * - noindex=true is used for private routes (cart, checkout, order, admin, wishlist)
 * - jsonLd accepts an object or array; rendered as application/ld+json
 */
const Seo = ({ title, description, canonicalPath = '/', image, noindex = false, jsonLd }) => {
  const canonical = `${SITE_URL}${canonicalPath}`;
  const ogImage = image || DEFAULT_OG_IMAGE;
  const robots = noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large';
  const ldArray = Array.isArray(jsonLd) ? jsonLd : (jsonLd ? [jsonLd] : []);
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {ldArray.map((obj, i) => (
        <script key={`ld-${i}`} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
